import React, { ReactNode, Suspense } from 'react';

import { StickyChat } from '@/app/_components/chat-content/StickyChat';
import { BackButtonHeader, ConversionHeader, DefaultFooter, LogoHeader, MainContainer } from '@/app/_components/layout-content/LayoutItems';
import { LayoutProps, LayoutHeaderProps, LayoutContainerClassNames } from '@/lib/types/layout';

export function LogoLayout({ children, isUseHeader = true, ...props }: LayoutHeaderProps & { children: ReactNode }) {
  return (
    <Suspense>
      {isUseHeader && <LogoHeader {...props} />}
      <MainContainer>{children}</MainContainer>
    </Suspense>
  );
}

export function BackButtonLayout({ children, isUseHeader = true, ...props }: LayoutProps & { children: ReactNode }) {
  return (
    <Suspense>
      {isUseHeader && <BackButtonHeader {...props} />}
      <MainContainer>{children}</MainContainer>
      {props.isUseDefaultFooter && <DefaultFooter />}
      {props.isUseStickyChat && <StickyChat viewMode={'sticky'} scrollButtonDirection={'bottom'} />}
    </Suspense>
  );
}

export function ConversionLayout({
  children,
  isUseHeader = true,
  classNames,
  ...props
}: LayoutProps & { children: ReactNode; classNames?: LayoutContainerClassNames }) {
  return (
    <Suspense>
      {isUseHeader && <ConversionHeader {...props} />}
      <MainContainer classNames={classNames}>{children}</MainContainer>
      {props.isUseDefaultFooter && <DefaultFooter />}
      {props.isUseStickyChat && <StickyChat viewMode={'sticky'} isAlwaysVisible={props.isAlwaysVisible} />}
    </Suspense>
  );
}
